<template>
<main>
  <!-- <h1>this.$route.query.flowId : {{ this.$route.query.flowId }}</h1>
  <h1>this.$route.query.shopId : {{ this.$route.query.shopId }}</h1>
  <h1>this.$route.query.jobNo : {{ this.$route.query.jobNo }}</h1> -->
</main>
</template>

<script>
import axios from 'axios' // api
// import moment from 'moment'
export default {
  data () {
    return {
      dataLineConfig: {},
      test: null,
      fullName: '=',
      shopId: '',
      jobNo: '',
      flowId: '',
      urlImg: ''
    }
  },
  async mounted () {
    this.shopId = this.$route.query.shopId
    this.jobNo = this.$route.query.jobNo
    this.flowId = this.$route.query.flowId
    let checkShopId = ''
    if (this.$route.query.shopId) {
      checkShopId = this.$route.query.shopId
    } else {
      const queryString = decodeURIComponent(window.location.search).replace(
        '?liff.state=',
        ''
      )
      console.log('queryString', queryString)
      const params = new URLSearchParams(queryString)
      checkShopId = params.get('shopId')
    }
    let dataLineConfig = await this.getDataLineConfig(checkShopId)
    this.dataLineConfig = dataLineConfig
    await this.getShop()
    await this.getJob()
    await this.checkLiffLogin(dataLineConfig)
    await this.$liff.closeWindow()
  },
  methods: {
    async getShop () {
      const i = await axios
        .get(this.DNS_IP + '/sys_shop/get?shopId=' + this.shopId)
      console.log('shop  : ', i)
      if (i.data.length) {
        this.urlImg = i.data[0].shopImge
      } else {
        this.urlImg = ''
      }
    },
    async getJob () {
      const resp = await axios.get(
        this.DNS_IP + '/job/get?jobNo=' + this.jobNo
      )
      if (resp.data.length > 0) {
        console.log('resp : job : ', resp)
        for await (const i of resp.data) {
          if (i.fieldName.trim() === 'ชื่อ') {
            this.fullName = i.fieldValue
          } else if (i.fieldName.trim() === 'เบอร์โทร') {
            this.TelData = i.fieldValue
          }
          this.empStepId = i.empStepId
        }
      } else {
        const resp = await axios.get(
          this.DNS_IP + '/job/getDelete?jobNo=' + this.jobNo
        )
        if (resp.data.length > 0) {
          console.log('resp : job : ', resp)
          for await (const i of resp.data) {
            if (i.fieldName.trim() === 'ชื่อ') {
              this.fullName = i.fieldValue
            } else if (i.fieldName.trim() === 'เบอร์โทร') {
              this.TelData = i.fieldValue
            }
            this.empStepId = i.empStepId
          }
        }
      }
    },
    async shareFlex () {
      let flex = {
        'type': 'flex',
        'altText': 'เช็คสถานะเรียลไทม์',
        'contents': {
          'type': 'bubble',
          'hero': {
            'type': 'image',
            'url': this.urlImg,
            'size': 'full',
            'aspectRatio': '20:13',
            'aspectMode': 'fit',
            'action': {
              'type': 'uri',
              'uri': 'https://line.me/'
            },
            'offsetTop': '10px'
          },
          'body': {
            'type': 'box',
            'layout': 'vertical',
            'contents': [
              {
                'type': 'text',
                'text': 'ได้รับสิทธิ์การเข้าถึงข้อมูล',
                'weight': 'bold',
                'size': 'lg',
                'align': 'center'
              },
              {
                'type': 'text',
                'text': this.fullName,
                'align': 'center',
                'size': 'lg',
                'margin': 'sm'
              }
            ]
          },
          'footer': {
            'type': 'box',
            'layout': 'vertical',
            'spacing': 'sm',
            'contents': [
              {
                'type': 'button',
                'style': 'primary',
                'height': 'sm',
                'action': {
                  'type': 'uri',
                  'label': 'เช็คสถานะเรียลไทม์',
                  'uri': 'https://betask-linked.web.app/shareFlowStep?flowId=' + this.$route.query.flowId + '&shopId=' + this.$route.query.shopId + '&jobNo=' + this.$route.query.jobNo
                }
              },
              {
                'type': 'box',
                'layout': 'vertical',
                'contents': [],
                'margin': 'sm'
              }
            ],
            'flex': 0
          }
        }

      }
      // let flex = {
      //   'type': 'text',
      //   'text': 'tessssssss'
      // }
      const result = await this.$liff.shareTargetPicker([
        flex
      ])
      if (result) {
        this.test = result.status
        // alert(`[${result.status}] Message sent!`)
      } else {
        this.test = 'false'
      }
    },
    async checkLiffLogin (dataLineConfig) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
            // await this.shareFlex()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile()
              await this.shareFlex()
            }
          }
        })
        .catch(err => {
          console.log(err.code, err.message)
        })
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Booking/ShareFlex.vue